import React from 'react'
import Responsive from 'react-responsive'
import { sizes } from 'themes'

const Desktop = props => <Responsive {...props} minWidth={sizes.desktop + 1} />

export { Desktop }
